<template>
  <div class="paper-container" style="display: flex">
    <div class="side">
      <Industry
        :sideList="sideList"
        @subClick="handleSub"
      ></Industry>
      <Learning
        :dataList="dataList"
        title="报告类型"
        @learnClick="handleLearn"
        @requestAll="handleAll"
      ></Learning>
    </div>
    <div class="content">
      <template v-if="itemList.length > 0 || scrollFlag">
        <Item
          v-for="(v, i) in itemList"
          :key="i"
          :every="v"
          :curcer="v.articleId"
          @itemClick="goDetail"
        ></Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
      </template>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/PCView/search/components/NoData.vue";
import Industry from "@/components/pager/Industry.vue";
import Learning from "@/components/pager/Learning.vue";
import Item from "@/components/pager/Item";
import mixin from "@/mixins";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    Industry,
    Item,
    Learning,
    NoData,
    Scroll
  },
  mixins: [mixin],
  data() {
    return {
      sideList: [], // 行业
      dataList: ["付费", "免费"],
      params: {
        articleType: 6,
        pageNo: 1,
      },
    };
  },
  created() {
    // 论文列表
    this.getItemList(this.params);
    this.getSideList(); // 行业
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/dataDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSub(v) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.businessId2 = v.id;
      this.getItemList({
        ...this.params,
      });
    },
    handleLearn(index) {
      this.filterFlag = true
      if (this.filterFlag) {
        this.pageNum = 1;
        this.itemList = [];
      }
      this.params.reportCharge = index;
      this.getItemList({
        ...this.params,
      });
    },
    async getSideList() {
      const resp = await this.$apis.wssjServe.getSideList();
      this.sideList = resp.indOneList;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
.side {
  width: 300px;
  margin-right: 11px;
}
.content {
  min-height: 1000px;
}
</style>
